import * as React from 'react'
import { useEffect, useRef, useState } from 'react'
import * as ReactDOM from 'react-dom'
// @ts-ignore
import { FroalaEditorView } from './react-editor/FroalaEditorView'

// Require Editor JS files.
import '@averystupidtest/editor/js/froala_editor.pkgd.min.js'
import '@averystupidtest/editor/js/plugins.pkgd.min.js'

import '@averystupidtest/editor/js/third_party/embedly.min.js'

// Require Editor CSS files.
import '@averystupidtest/editor/css/froala_editor.pkgd.min.css'
import '@averystupidtest/editor/css/froala_style.min.css'

import '@averystupidtest/editor/css/third_party/embedly.min.css'

import { getTributeComponentsFromHtml } from './parser'
import { RichTextViewerProps, TributeComponentParams } from './types'

import * as styles from './RichTextViewer.module.less'

export const RichTextViewer: React.FC<RichTextViewerProps> = (props) => {
    const { getTributeComponent } = props
    const richTextViewerRef = useRef<HTMLDivElement>(null)

    const [richTextViewerElement, setRichTextViewerElement] = useState<
        HTMLDivElement
    >()
    const content = props.content

    const onLinkClick = (url: string) => {
        props.onLinkClick && props.onLinkClick(url)
    }

    // Add the onClick events to all the <a/> we find (shall we use on... for mobile?)
    useEffect(() => {
        if (richTextViewerRef.current) {
            setRichTextViewerElement(richTextViewerRef.current)
        }
    }, [richTextViewerRef])

    // Component will unmount
    useEffect(() => {
        return () => {
            if (richTextViewerElement) {
                const embeddedComponents = richTextViewerElement.querySelectorAll(
                    '.schedio-tribute-link[data-href]'
                )

                Array.from(embeddedComponents).forEach((c) => {
                    const url = c.getAttribute('data-href')
                    c.removeEventListener(
                        'click',
                        () => {
                            if (url) {
                                return onLinkClick(url)
                            }
                        },
                        false
                    )
                })
            }
        }
    }, [])

    // Add the onClick events to all the <a/> we find (shall we use on... for mobile?)
    useEffect(() => {
        if (richTextViewerElement) {
            const components = richTextViewerElement.querySelectorAll(
                '.schedio-tribute-link[data-href]'
            )
            Array.from(components).forEach((c: Element) => {
                const params = getComponentParams(c)
                const url = c.getAttribute('data-href')
                c.addEventListener(
                    'click',
                    () => {
                        if (url) {
                            return onLinkClick(url)
                        }
                    },
                    false
                )
            })
        }
    }, [content, richTextViewerElement, richTextViewerRef])

    // Add the components dynamically to each wrapper id.
    useEffect(() => {
        if (richTextViewerElement && getTributeComponent) {
            const htmlDbComponents = getTributeComponentsFromHtml(
                richTextViewerElement
            )

            htmlDbComponents &&
                htmlDbComponents.map((htmlDbComp) => {
                    const params = getComponentParams(htmlDbComp)
                    const Component = getTributeComponent(params).Component
                    ReactDOM.render(
                        Component,
                        document.getElementById(params.domId)
                    )
                })
        }
    }, [richTextViewerElement, content])

    // Prevents to set Viewer as Editor if user clicks on a link.
    const onEditorClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if ((e.target as any).href !== undefined) {
            e.stopPropagation()
        }
    }

    return (
        <div
            className={styles.richTextViewer}
            ref={richTextViewerRef}
            onClick={onEditorClick}
        >
            <FroalaEditorView model={content} />
        </div>
    )
}

export const getComponentParams = (
    component: Element
): TributeComponentParams => {
    const domId = component.getAttribute('id') || ''
    const type = component.getAttribute('data-tribute-type') || ''
    const organization =
        component.getAttribute('data-tribute-organization') || ''
    const ppm = component.getAttribute('data-tribute-ppm') || ''
    const title = component.getAttribute('data-tribute-title') || ''
    const wbsComponent =
        component.getAttribute('data-tribute-wbscomponent') || ''
    const workItem = component.getAttribute('data-tribute-workitem') || ''

    return { domId, organization, ppm, title, type, wbsComponent, workItem }
}
